module.exports = __webpack_public_path__ + "img/fatherDay.2c7b5f02.png";